module.exports = "<md-slider id=\"seekbar\" mdTooltipPosition=\"below\" mdTooltip=\"{{position | humanTime}}/{{duration| humanTime}}\" class=\"md-primary\" min=\"0\" max=\"{{duration}}\" step=\"5\" [(ngModel)]=\"position\" (change)=\"onChange()\"></md-slider>\n<span>&nbsp;<!--{{position | humanTime}}/{{duration| humanTime}}--></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/seek-track/seek-track.component.html
// module id = ./src/app/player/seek-track/seek-track.component.html
// module chunks = main